




































































// vue
import { defineComponent, ref, Ref } from '@vue/composition-api'

// service
import { ReportPlameService } from '@/services/reports'

// componnents
import { PageHeader } from '@/components'
import { DataTable } from '@/components/table'
import { Select2 } from '@/components/form'
import { DatePicker } from '@/components/general'

// utils
import { dateLibs } from '@/utils'

// types
import { ReportPlameItemBase } from '@/models/reports/ReportPlame'

export default defineComponent({
  name: 'ReportPlame',
  components: {
    PageHeader,
    DatePicker,
    Select2,
    DataTable
  },
  setup () {
    const loading = ref(false)
    const title = ref('Reporte plame')
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Reporte Plame',
        active: true
      }
    ]
    const year: Ref<number|null> = ref(null)
    const month: Ref<number|null> = ref(null)
    const items: Ref<ReportPlameItemBase[]> = ref([])

    const fields = [
      {
        key: 'number',
        sortable: false,
        label: '#'
      },
      {
        key: 'employee',
        sortable: false,
        label: 'Empleado'
      },
      {
        key: 'employee.document_number',
        sortable: false,
        label: 'Número De Documento'
      },
      {
        key: 'ruc',
        sortable: false,
        label: 'Ruc del otro empleador'
      },
      {
        key: 'amount_received',
        sortable: false,
        label: 'Importe percibido'
      },
      {
        key: 'ensures_pension',
        sortable: false,
        label: 'Asegura tu pensión',
        formatter: (value: boolean) => value ? 1 : 0
      },
      {
        key: 'essalud',
        sortable: false,
        label: '+Vida seguro de accidentes (Essalud + vida)',
        formatter: (value: boolean) => value ? 1 : 0
      },
      {
        key: 'fdsa',
        sortable: false,
        label: 'Indicador de aporte al Fondo de Derechos Sociales del Artista (FDSA) o de retención de Régimen Pensionario - ley 29903'
      },
      {
        key: 'domiciled',
        sortable: false,
        label: 'Domiciliado'
      },
      {
        key: 'rate_type',
        sortable: false,
        label: '1: SCTR ESSALUD 2: Convenio IES'
      },
      {
        key: 'rate',
        sortable: false,
        label: 'Tasa'
      },
      {
        key: 'hours_worked',
        sortable: false,
        label: 'Número De Horas Ordinarias Trabajadas '
      }
    ]

    const generate = async (year: number, month: number) => {
      loading.value = true
      items.value = await ReportPlameService.generatePlameReport(year, month)
      loading.value = false
    }

    const search = async () => {
      if (year.value && year.value > 0 && month.value && month.value > 0) {
        loading.value = true
        const plame = await ReportPlameService.getPlameReportByFilter(year.value, month.value)
        loading.value = false
        if (plame) {
          // Extraer el que ya existe.
        } else {
          generate(year.value, month.value)
        }
      }
    }

    return {
      title,
      breadcrumbs,
      years,
      months,
      year,
      month,
      fields,
      items,
      loading,
      search
    }
  }
})
